import { api ,getBlob} from "../../services/NetworkBase";
// import { getBlob } from "./networkService";
import { saveAs } from "file-saver";

export async function GetUserRoutes() {
  try {
    let response = await api.get(`vlp/user-routes`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetUserRoutesByCriteria(startDate,endDate,isCompleted,searchText) {	
	try {
		let response = await api
		.get(`vlp/user-routes/criteria?startDate=${startDate}&endDate=${endDate}&isCompleted=${isCompleted}&searchText=${searchText}`)
			.json();
		return response;
	} catch (error) {
		throw error;
	}
}


export async function GetUserRouteById(routeId) {
  try {
    let response = await api.get(`vlp/user-routes/${routeId}`).json();
    return response;
  } catch (error) {
    throw error;
  }
}
export async function UpdateUserRoute(route) {  
  try {
    let response = await api.put("vlp/user-routes", { json: route });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function SaveUserRoute(route) {
  try {
    let response = await api.post("vlp/user-routes", { json: route }).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function DeleteUserRoute(routeId) {
  try {
    const encodedUrl = encodeURIComponent(routeId);
    let response = await api
      .delete(`vlp/user-routes/${encodedUrl}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function MarkCompletedUserRoute(routeId) {
  try {
    const encodedUrl = encodeURIComponent(routeId);
    let response = await api
      .put(`vlp/user-routes/${encodedUrl}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function PrintUserRouteCoC(clients) {
  const encodedClients = encodeURIComponent(clients);
  let blob = await getBlob(`vlp/user-routes/coc/${clients}`);
  const url = window.URL.createObjectURL(blob);
  window.open(url, "_blank");
  saveAs(blob, `Consolidated_Pool_CoC.pdf`);
}


export async function PrintUserRouteDoc(routeId) {
  let blob = await getBlob(`vlp/user-routes/pickup-doc/${routeId}`);
  const url = window.URL.createObjectURL(blob);
  window.open(url, "_blank");
  saveAs(blob, `${routeId}.pdf`);
}


export async function DuplicateUserRoute(routeId,selectedRoute) {
  try {
    const encodedUrl = encodeURIComponent(routeId);
    let response = await api
      .put(`vlp/user-routes/${encodedUrl}/duplicate`, { json: selectedRoute })
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}
